import { render, staticRenderFns } from "./ListPagesCapituloView.vue?vue&type=template&id=5e62cd32&scoped=true"
import script from "./ListPagesCapituloView.vue?vue&type=script&lang=js"
export * from "./ListPagesCapituloView.vue?vue&type=script&lang=js"
import style0 from "./ListPagesCapituloView.vue?vue&type=style&index=0&id=5e62cd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e62cd32",
  null
  
)

export default component.exports